import React from 'react';

const Story = () => {
    return (
        <div className='mb-10 mx-12'>
            <h1 className='text-3xl text-center my-10'>About Carpenters Hub</h1>
            <p className='text-left text-xl'> <span className='text-amber-400 font-bold'>Carpenters-Hub </span> was established in year of 2010. It is a Manufacturer shop where you can find all the necessary products for the  carpentry work. In the year of 2022 we have launched the Carpenters hub website to grow our reach all over the world. Now we are a global supplier with a large user and 50+ countries. You can order product from us as much as you required. We are providing you trusted online payment system to give your payment safely. Our delivery service is quite good as we try to deliver your products on time. </p>

        </div>
    );
};

export default Story;